'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
// import InfoIcon from '@/components/ui/icons/InfoIcon';
import RealTaxFreeTravelerIcon from '@/components/ui/icons/RealTaxFreeTravelerIcon';
import ComplianceTravelerIcon from '@/components/ui/icons/ComplianceTravelerIcon';
import InstantTravelerIcon from '@/components/ui/icons/InstantTravelerIcon';
import FastTravelerIcon from '@/components/ui/icons/FastTravelerIcon';
import ValidationTravelerIcon from '@/components/ui/icons/ValidationTravelerIcon';
import styles from './WhySection.module.css';

export default function WhySection() {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.whySection}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>{t('whySection.title')}</h2>
          <p className={styles.subtitle}>{t('whySection.subtitle')}</p>
        </div>

        <div className={styles.benefitsContainer}>
          <div className={styles.benefit}>
            <div className={styles.iconContainer}>
              <RealTaxFreeTravelerIcon className={styles.icon} />
            </div>
            <h3 className={styles.benefitTitle}>{t('whySection.realTaxFree.title')}</h3>
            <p className={styles.benefitDescription}>{t('whySection.realTaxFree.description')}</p>
          </div>

          <div className={styles.benefit}>
            <div className={styles.iconContainer}>
              <ComplianceTravelerIcon className={styles.icon} />
            </div>
            <h3 className={styles.benefitTitle}>{t('whySection.fullyCompliant.title')}</h3>
            <p className={styles.benefitDescription}>
              {t('whySection.fullyCompliant.description')}
            </p>
          </div>

          <div className={styles.benefit}>
            <div className={styles.iconContainer}>
              <InstantTravelerIcon className={styles.icon} />
            </div>
            <h3 className={styles.benefitTitle}>{t('whySection.instantInvoice.title')}</h3>
            <p className={styles.benefitDescription}>
              {t('whySection.instantInvoice.description')}
            </p>
          </div>

          <div className={styles.benefit}>
            <div className={styles.iconContainer}>
              <FastTravelerIcon className={styles.icon} />
            </div>
            <h3 className={styles.benefitTitle}>{t('whySection.fastCheckout.title')}</h3>
            <p className={styles.benefitDescription}>{t('whySection.fastCheckout.description')}</p>
          </div>

          <div className={styles.benefit}>
            <div className={styles.iconContainer}>
              <ValidationTravelerIcon className={styles.icon} />
            </div>
            <h3 className={styles.benefitTitle}>{t('whySection.simpleValidation.title')}</h3>
            <p className={styles.benefitDescription}>
              {t('whySection.simpleValidation.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
